import { render, staticRenderFns } from "./VasionApplySignature.vue?vue&type=template&id=6c4c1b00&scoped=true"
import script from "./VasionApplySignature.vue?vue&type=script&lang=js"
export * from "./VasionApplySignature.vue?vue&type=script&lang=js"
import style0 from "./VasionApplySignature.vue?vue&type=style&index=0&id=6c4c1b00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4c1b00",
  null
  
)

export default component.exports